import { Notifications } from '@extranet-ts/components/common/notifications';
import { NotificationContext } from '@extranet-ts/components/contexts/notification_context/notification_context';
import { Notification } from '@extranet-ts/components/contexts/notification_context/notification_context.types';
import * as React from 'react';
import { useState } from 'react';

export const NotificationContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  function addNotification(notification: Notification, clearBeforeAdd = false) {
    notification.id = Math.random().toString(16).slice(2);
    if (clearBeforeAdd) {
      setNotifications([notification]);
    } else {
      setNotifications((prevNotification) => [...prevNotification, notification]);
    }
    setTimeout(() => deleteNotification(notification.id), 5000);
    return notification.id;
  }

  function deleteNotification(id: string) {
    setNotifications((notifications) => notifications.filter((n) => n.id != id));
  }

  return (
    <>
      <NotificationContext.Provider value={{ addNotification, deleteNotification }}>
        {children}
      </NotificationContext.Provider>
      <Notifications notifications={notifications} deleteNotification={deleteNotification} />
    </>
  );
};
